import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
    selector: 'app-simple-layout',
    standalone: true,
    templateUrl: './simple-layout.component.html',
    imports: [RouterOutlet],
    styleUrls: ['./simple-layout.component.scss']
})
export class SimpleLayoutComponent {}
